// Mock data for SAP Commerce Cloud Portal

// User information
export const mockUser = {
  name: 'John Smith',
  email: 'john.smith@example.com',
  avatar: 'https://i.pravatar.cc/150?img=1'
};

// Dashboard metrics
export const mockMetrics = {
  totalGMV: 1285430,
  conversionRate: 3.24,
  dailyActiveUsers: 8459,
  growthRate: 12.5
};

// GMV time series data (last 30 days)
export const mockGMVTrend = [
  { date: '11-05', gmv: 38500 },
  { date: '11-06', gmv: 42300 },
  { date: '11-07', gmv: 39800 },
  { date: '11-08', gmv: 45200 },
  { date: '11-09', gmv: 41900 },
  { date: '11-10', gmv: 48500 },
  { date: '11-11', gmv: 62300 },
  { date: '11-12', gmv: 44200 },
  { date: '11-13', gmv: 41500 },
  { date: '11-14', gmv: 43800 },
  { date: '11-15', gmv: 46900 },
  { date: '11-16', gmv: 49200 },
  { date: '11-17', gmv: 51500 },
  { date: '11-18', gmv: 47800 },
  { date: '11-19', gmv: 45300 },
  { date: '11-20', gmv: 48900 },
  { date: '11-21', gmv: 52100 },
  { date: '11-22', gmv: 49500 },
  { date: '11-23', gmv: 51200 },
  { date: '11-24', gmv: 53800 },
  { date: '11-25', gmv: 55400 },
  { date: '11-26', gmv: 52900 },
  { date: '11-27', gmv: 54700 },
  { date: '11-28', gmv: 57200 },
  { date: '11-29', gmv: 59100 },
  { date: '11-30', gmv: 56800 },
  { date: '12-01', gmv: 58400 },
  { date: '12-02', gmv: 61200 },
  { date: '12-03', gmv: 59700 },
  { date: '12-04', gmv: 62500 }
];

// GMV by sales channel
export const mockGMVByChannel = [
  { channel: 'E-commerce', gmv: 485200, orders: 1842 },
  { channel: 'ChatGPT', gmv: 328400, orders: 956 },
  { channel: 'Gemini', gmv: 215800, orders: 687 },
  { channel: 'Perplexity', gmv: 156300, orders: 421 },
  { channel: 'Shopping Agent', gmv: 125600, orders: 389 },
  { channel: 'Universal MCP', gmv: 99730, orders: 312 }
];

// GMV by product category
export const mockGMVByCategory = [
  { category: 'Electronics', gmv: 425600, percentage: 33 },
  { category: 'Apparel & Accessories', gmv: 321800, percentage: 25 },
  { category: 'Home & Living', gmv: 256900, percentage: 20 },
  { category: 'Beauty & Personal Care', gmv: 180530, percentage: 14 },
  { category: 'Others', gmv: 100600, percentage: 8 }
];

// Sales channels
export const mockSalesChannels = [
  {
    id: 1,
    name: 'Official Flagship Store',
    type: 'ecommerce',
    typeName: 'E-commerce',
    status: 'active',
    configStatus: 'complete',
    createdAt: '2024-10-15',
    domain: 'shop.example.com',
    monthlyGMV: 485200
  },
  {
    id: 2,
    name: 'ChatGPT Shopping Assistant',
    type: 'chatgpt',
    typeName: 'OpenAI ChatGPT',
    status: 'active',
    configStatus: 'complete',
    createdAt: '2024-11-01',
    monthlyGMV: 328400
  },
  {
    id: 3,
    name: 'Gemini Shopping Channel',
    type: 'gemini',
    typeName: 'Google Gemini',
    status: 'active',
    configStatus: 'complete',
    createdAt: '2024-11-10',
    monthlyGMV: 215800
  },
  {
    id: 4,
    name: 'Perplexity Shop',
    type: 'perplexity',
    typeName: 'Perplexity',
    status: 'inactive',
    configStatus: 'incomplete',
    createdAt: '2024-11-20',
    monthlyGMV: 156300
  },
  {
    id: 5,
    name: 'Universal MCP Service',
    type: 'mcp',
    typeName: 'Universal MCP',
    status: 'active',
    configStatus: 'complete',
    createdAt: '2024-11-25',
    monthlyGMV: 99730
  },
  {
    id: 6,
    name: 'Website Chat Assistant',
    type: 'shopping-agent',
    typeName: 'Shopping Agent',
    status: 'active',
    configStatus: 'complete',
    createdAt: '2024-12-01',
    monthlyGMV: 125600
  }
];

// Product categories (for wizards)
export const mockProductCategories = [
  { id: 1, name: 'Electronics', productCount: 156 },
  { id: 2, name: 'Apparel & Accessories', productCount: 234 },
  { id: 3, name: 'Home & Living', productCount: 189 },
  { id: 4, name: 'Beauty & Personal Care', productCount: 145 },
  { id: 5, name: 'Sports & Outdoors', productCount: 98 },
  { id: 6, name: 'Food & Beverages', productCount: 167 },
  { id: 7, name: 'Books & Entertainment', productCount: 78 },
  { id: 8, name: 'Baby & Toys', productCount: 123 }
];

// Theme options for e-commerce wizard
export const mockThemeOptions = [
  { id: 'modern', name: 'Modern Minimalist', preview: '#3f51b5' },
  { id: 'classic', name: 'Classic Business', preview: '#000000' },
  { id: 'colorful', name: 'Vibrant & Colorful', preview: '#ff5722' },
  { id: 'minimal', name: 'Minimalist', preview: '#9e9e9e' }
];

// Layout options for e-commerce wizard
export const mockLayoutOptions = [
  { id: 'grid', name: 'Grid Layout', description: 'Ideal for displaying large product catalogs' },
  { id: 'list', name: 'List Layout', description: 'Perfect for detailed product information' },
  { id: 'masonry', name: 'Masonry Layout', description: 'Great for visual impact' },
  { id: 'carousel', name: 'Carousel Layout', description: 'Best for featured products' }
];
